import axios from "axios";
import { AUTHORIZE_BASE_URL, AUTHORIZE_HEALTH_URL } from "../utils/EmpUtil";
import { is500 } from "../errors/ErrorConstants";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";

export default class AuthenticationClient {
  static baseUrl = AUTHORIZE_BASE_URL;
  static healthUrl = AUTHORIZE_HEALTH_URL;

  /**
   * @param {object} authenticationRequest - Request params (salesCode, page, etc.)
   * @param {object} options - Optional. Use { skipAuthFailureHandler: true } when calling from initial auth flow (e.g. MsalAuthWrapper)
   *   to avoid reload loop - caller will handle 401 by showing an error screen instead.
   */
  static status(authenticationRequest, options = {}) {
    const url = `${this.baseUrl}/authorize`;
    const skipAuthFailureHandler = options.skipAuthFailureHandler === true;

    return axios
      .post(url, authenticationRequest)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (!is500(error) && !skipAuthFailureHandler) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static async health() {
    const url = this.healthUrl;

    return axios
      .get(url)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (!is500(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }
}
